import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    favoritesId: {
      type: Number,
      default: null
    }
  },
  methods: {
    cancle: function cancle() {
      this.$emit('delCollectFn', {
        bool: false
      });
    },
    commit: function commit() {
      var _this = this;
      this.$API.postRequest({
        url: "/platform/favorite/delete?id=".concat(this.favoritesId)
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this.$message({
            message: '删除收藏夹成功',
            type: 'success'
          });
          _this.$emit('delCollectFn', {
            bool: true
          });
        }
      });
    }
  }
};